export const VGL_COMPANY_NAME =
   'LIGENTIA DISTRIBUTION SERVICES SPÓŁKA Z OGRANICZONĄ ODPOWIEDZIALNOŚCIĄ';
export const TARCZYNSKI_COMPANY_NAME = 'TARCZYŃSKI SPÓŁKA AKCYJNA';
